export default function PrivacyPolicy() {
    return (
      <div className="d-flex align-items-center justify-content-center flex-column gap-4" style={{ padding: "20px" }}>
        <h1>Privacy Policy</h1>
        <p>We use cookies to improve your experience. Your data is safe with us.</p>
        <h2>What Data We Collect</h2>
        <p>We collect cookies for analytics, security, and user experience improvement.</p>
        <h2>Managing Your Cookies</h2>
        <p>You can manage your cookie preferences <a href="/">here</a>.</p>
      </div>
    );
  }
  